import StartPage from "./StartPage";

import registrationStep from "../../registrationStep";

export default registrationStep(StartPage, "start", "searching");

// export default connect(
//   null, // No State
//   (dispatch, ownProps) => ({
//     onSubmit: (email) => {
//       dispatch(Creators.beginRegistration(email))
//     }
//   })
// )(StartPage);



// WEBPACK FOOTER //
// ./src/registration/components/Start/index.js